import React from 'react';
import { OfferCountdown } from './OfferCountdown';
export function SiteHeader() {
  return <header className="sticky top-0 z-30 border-b border-line/60 bg-ink/90 backdrop-blur" data-id="element-196" data-mp="19w1d92r93nzf">
      <div className="mx-auto flex h-14 max-w-6xl items-center justify-between gap-3 px-5 md:h-16 md:px-6" data-id="element-197" data-mp="1nmmy2x09m7zy">
        <a href="#inicio" className="font-display text-xs tracking-[0.15em] text-cream md:text-sm md:tracking-[0.2em]" data-id="element-198" data-mp="1inbgxmvzl0hu">
          El Libro del Despertar
        </a>
        <OfferCountdown data-id="element-199" data-mp="qx5klvv1jhnp" />
      </div>
    </header>;
}